import React from 'react';
import DOMPurify from 'dompurify';
import ContentEditable, { ContentEditableEvent } from 'react-contenteditable';
import { extractValue } from './RichtextGroupHelpers';
import IconButton from 'shared/buttons/IconButton';
import { setAction } from '../../../redux/actions/projectConfig';
import { useDispatch } from 'react-redux';
import { GenericInputProps } from 'shared/types/commonPropTypes';

const RichtextGroupWidget = (props: GenericInputProps) => {
  const { option, chart, aggregatedOptions, type } = props;
  const dispatch = useDispatch();

  const onChange = (e: ContentEditableEvent) => {
    props.onChange({ val: e.target.value });
  };

  const makeRichtextBox = () => {
    const { option } = props;
    dispatch(
      setAction({
        richtextGroupOptions: {
          option,
          box: document.querySelector(`.highed-richtext-field.${option?.className}`)
        }
      })
    );
  };

  const newValue = extractValue(type, option, chart, aggregatedOptions);
  let text = DOMPurify.sanitize(newValue.text ?? '');
  if (option?.richtext?.removeWatermark) {
    text = text.replace(' © <a href="http://www.naturalearthdata.com">Natural Earth</a>', '');
  }

  return (
    <div className="flex flex-col mt-2">
      <div className="text-ev-navy-blue font-bold mb-2">{props.label}</div>
      <div className="highed-field-container" id={`${option?.id}`}>
        <ContentEditable
          id={option?.id}
          className={`highed-field-input break-all highed-richtext-field group ${option?.className}`}
          html={text}
          onChange={onChange}
          suppressContentEditableWarning={true}
        />

        <IconButton
          icon="pencil"
          className="w-8 h-8 absolute top-[5px] right-[5px] rounded"
          onClick={makeRichtextBox}
        />
      </div>
    </div>
  );
};

export default RichtextGroupWidget;
